export function getHost(){

let url=process.env.VUE_APP_BASE_PATH_H5
 let login_host=''
 let www_host=''
  // 适配多个域名
  let arr=window.location.host.split('.')
  if(url.indexOf('-uat')>-1){//uat环境
      login_host='https://m-uat.'+arr[1]+"."+arr[2]
      www_host='https://portal-ysc.'+arr[1]+"."+arr[2]
  }else if(url.indexOf('dev')>-1){//dev
      login_host='https://m-dev.'+arr[1]+"."+arr[2]
       www_host='https://online-dev.'+arr[1]+"."+arr[2]
  }else{//正式环境
      login_host='https://m.'+arr[1]+"."+arr[2]
      www_host='https://www.'+arr[1]+"."+arr[2]
  }
  return {
    login_host,
    www_host
  }
}

export function setCookies (name, value, days){
    //设置cookie
    var exp = new Date();
    if (days === -1) {
        exp.setTime(exp.getTime() - 1);
    } else {
        exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
    }
    let url=window.location.host 
    let arr=url.split('.')
    let domain="."+arr[1]+"."+arr[2]
    // var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
    document.cookie =
        name +
        "=" +
        value +
        "; Expires=" +
        exp.toUTCString() +
        "; Domain="+domain+
        "; Path=/; SameSite=none; Secure";
   


};

// 解析URL中encodeURIComponent编码的参数
export function getQueryString(name) {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

// 解析URL中escape编码的参数
export function getString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export function zhugeTrack(clickName, obj, skipUrl) {
  //诸葛
  try {
    zhuge.track(clickName, obj, function () {
      if (skipUrl) {
        window.location.href = skipUrl;
      }
    });
  } catch (e) {
   
  }
}

export function comPop(text) {
  var str = `<p>${text}</p>`;
  var div = document.createElement("div");
  var body = document.getElementsByTagName("body")[0];
  div.className = "layer";

  div.innerHTML = str;
  if (body.getElementsByClassName("layer").length <= 0) {
    body.appendChild(div);
  } else {
    document.getElementsByClassName("layer")[0].innerHTML = str;
  }
  setTimeout(function () {
    div.remove();
  }, 2000);
}

// 登录后的跳转
export function jumpAfterLogin(referUrl) {
  if (referUrl) {
    window.location.href = referUrl;
  } else {
    window.location.href = getHost().www_host + "/404";
  }
}

//功能：根据用户输入的Email跳转到相应的电子邮箱首页
export function gotoEmail($mail) {
  var $t;
  $t = $mail.split("@")[1];
  $t = $t.toLowerCase();
  if ($t == "163.com") {
    return "mail.163.com";
  } else if ($t == "vip.163.com") {
    return "vip.163.com";
  } else if ($t == "126.com") {
    return "mail.126.com";
  } else if ($t == "qq.com" || $t == "vip.qq.com" || $t == "foxmail.com") {
    return "mail.qq.com";
  } else if ($t == "gmail.com") {
    return "mail.google.com";
  } else if ($t == "sohu.com") {
    return "mail.sohu.com";
  } else if ($t == "tom.com") {
    return "mail.tom.com";
  } else if ($t == "vip.sina.com") {
    return "vip.sina.com";
  } else if ($t == "sina.com.cn" || $t == "sina.com") {
    return "mail.sina.com.cn";
  } else if ($t == "tom.com") {
    return "mail.tom.com";
  } else if ($t == "yahoo.com.cn" || $t == "yahoo.cn") {
    return "mail.cn.yahoo.com";
  } else if ($t == "tom.com") {
    return "mail.tom.com";
  } else if ($t == "yeah.net") {
    return "www.yeah.net";
  } else if ($t == "21cn.com") {
    return "mail.21cn.com";
  } else if ($t == "hotmail.com") {
    return "www.hotmail.com";
  } else if ($t == "sogou.com") {
    return "mail.sogou.com";
  } else if ($t == "188.com") {
    return "www.188.com";
  } else if ($t == "139.com") {
    return "mail.10086.cn";
  } else if ($t == "189.cn") {
    return "webmail15.189.cn/webmail";
  } else if ($t == "wo.com.cn") {
    return "mail.wo.com.cn/smsmail";
  } else if ($t == "itcast.cn") {
    return "mm.263.com";
  } else {
    return "";
  }
}

// qq登录校验
export function refer(url, referUrl) {
  if (referUrl.indexOf("login") != -1 || referUrl.indexOf("register") != -1) {
    var refer = getQueryString("refer")
      ? encodeURIComponent(encodeURI(getQueryString("refer")))
      : "";
    if (refer) {
      window.location.href = url + refer;
    } else {
      window.location.href = url + basePathOnline;
    }
  } else {
    window.location.href = url + encodeURIComponent(encodeURI(referUrl));
  }
}
